<template>
    <v-dialog v-model="show" max-width="800" scrollable persistent no-click-animation>
        <div class="CampaignCustomerProperties">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('customerProperties') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar">
                <div class="editor-actions">
                    <div class="btn-outline mr-6" @click="importCustomerProperties">
                        <img src="/img/add-blue.svg" alt="icon-add-mapping-excel"
                             style="margin-right: 6px; transform: scale(1.1)">
                        {{ $f.tc('importFromExcel') }}
                        <input type="file" :hidden="true" ref="InputCustomerProperties" accept=".xlsx, .xls, .csv"
                               @change="handleFile">
                    </div>
                    <div class="btn-outline mr-6" style="width: 32px" @click="downloadTemplate"
                         :title="$f.tc('downloadTemplateExcel')">
                        <img src="/img/scenario/download_blue.svg" alt="icon-download-template">
                    </div>
                    <div class="btn-custom mr-0" @click="openCustomerPropertyCreator">
                        <img src="/img/add.svg" alt="icon-add" style="transform: scale(1.2); margin-right: 8px">
                        {{ $f.tc('addNew') }}
                    </div>
                </div>
                <v-form ref="editForm">
                    <table class="property-table">
                        <thead>
                        <tr>
                            <th>{{ $f.tc('key') }}</th>
                            <th>{{ $f.tc('title') }}</th>
                            <th class="text-center">{{ $f.tc('required') }}</th>
                            <th style="width: 100px;">
                                <div class="centerXY">
                                    {{ $f.tc('unique') }}
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon color="#0052CC" small v-on="on" style="margin-left: 3px">
                                                mdi-help-circle
                                            </v-icon>
                                        </template>
                                        <span>
                                            Unique property is used to distinguish between customers. <br>
                                            In case you want to change unique property, please remove all existed customers first
                                        </span>
                                    </v-tooltip>
                                </div>
                            </th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="property in fixedPropertyList" :key="property.id">
                            <td>
                                <v-text-field
                                    :disabled="true"
                                    :value="property.name"
                                    class="input-custom"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    :disabled="true"
                                    :value="property.description"
                                    class="input-custom"
                                ></v-text-field>
                            </td>
                            <td>
                                <div style="margin-left: 40px">
                                    <v-checkbox
                                        v-model="property.isRequired"
                                        :disabled="property.name!=='name'"
                                        hide-details
                                        color="#0052CC"
                                    ></v-checkbox>
                                </div>
                            </td>
                            <td v-if="property.name !== 'name'">
                                <v-radio-group v-model="unique" :mandatory="true" style="margin-left: 32px">
                                    <v-radio hide-details :value="property.id" :disabled="!uniqueEditable"
                                             color="#0052CC"></v-radio>
                                </v-radio-group>
                            </td>
                            <td></td>
                        </tr>
                        <tr v-for="(property, i) in newPropertyList" :key="property.id">
                            <td>
                                <v-text-field
                                    class="input-custom"
                                    v-model="property.name"
                                    :rules="[checkKeyExisted.bind(this, i), formRules.ruleRequired]"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    class="input-custom"
                                    v-model="property.description"
                                    :rules="[checkTitleExisted.bind(this, i),formRules.ruleRequired]"
                                ></v-text-field>
                            </td>
                            <td>
                                <div style="margin-left: 40px">
                                    <v-checkbox
                                        v-model="property.is_required"
                                        hide-details
                                        color="#0052CC"
                                        :disabled="property.id === unique"
                                    ></v-checkbox>
                                </div>
                            </td>
                            <td>
                                <v-radio-group v-model="unique" :mandatory="true" style="margin-left: 32px">
                                    <v-radio hide-details :value="property.id" :disabled="!uniqueEditable"
                                             color="#0052CC"></v-radio>
                                </v-radio-group>
                            </td>
                            <td>
                                <v-icon
                                    v-if="uniqueEditable || property.id !== unique"
                                    @click="removeProperty(i)"
                                >mdi-window-close
                                </v-icon>
                            </td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
                </v-form>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-custom" @click="save">{{ $f.tc('save') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
            <!--Dialog create new customer property-->
            <CustomerPropertyCreator ref="CustomerPropertyCreator"
                                     :property-list="[...fixedPropertyList, ...newPropertyList]"></CustomerPropertyCreator>
        </div>
    </v-dialog>
</template>
<script>
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import { mapState } from 'vuex'
import CustomerPropertyCreator from '@/views/Campaign/Form/Step3/CustomerPropertyCreator'
import $const from '@/utils/const'

export default {
    name: 'CampaignCustomerProperties',
    components: { CustomerPropertyCreator },
    mixins: [
        FormMixin, DialogMixin
    ],
    props: {
        uniqueEditable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            formAddValid: false,
            newPropertyList: [],
            oldPropertyList: [],
            fixedPropertyList: [
                {
                    id: '_name',
                    name: 'name',
                    description: 'Name',
                    isRequired: false,
                    isUnique: false
                },
                {
                    id: '_phone',
                    name: 'phone',
                    description: 'Phone',
                    isRequired: true,
                    isUnique: true
                }
            ],
            unique: '_phone',
            oldUnique: '_phone',
            file: '',
            oldRequiredName: false,
            updateRequiredName: 0,
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            campaignConfig: state => state.campaign.campaignConfig
        })
    },
    methods: {
        open () {
            if (this.campaignConfig){
                this.fixedPropertyList[0].isRequired = this.campaignConfig.required_customer_name ? this.campaignConfig.required_customer_name : false
            }
            this.oldRequiredName = this.fixedPropertyList[0].isRequired
            this.show = true
            this.newPropertyList = []
            this.unique = '_phone'
            this.oldUnique = '_phone'
            this.$appService.showLoading()
            CampaignService.getCustomerProperties(this.campaign).then(res => {
                if (res.data?.length) {
                    this.oldPropertyList = res.data
                    this.newPropertyList = JSON.parse(JSON.stringify(res.data))
                    for (let property of this.newPropertyList) {
                        if (property.is_unique) {
                            this.unique = property.id
                            this.oldUnique = property.id
                            break
                        }
                    }
                }
            }).finally(this.$appService.hideLoading)
        },
        removeProperty (index) {
            if (this.newPropertyList[index].id === this.unique) {
                this.unique = '_phone'
            }
            this.newPropertyList.splice(index, 1)
        },
        async save () {
            this.updateRequiredName = 0
            if (this.oldRequiredName !== this.fixedPropertyList[0].isRequired) {
                let data = {
                    'required_customer_name': this.fixedPropertyList[0].isRequired
                }
                await CampaignService.updateRequiredName(this.campaign.id, data).then(res => {
                    this.updateRequiredName = 1
                    this.oldRequiredName = this.fixedPropertyList[0].isRequired
                    this.$store.commit(this.$actionTypes.campaign.SET_CAMPAIGN_CONFIG, res.data)
                    this.$appService.toastSuccess('Update required name success')
                })
            }
            let oldPropertyMap = {}
            for (let property of this.oldPropertyList) {
                oldPropertyMap[property.id] = property
            }
            let newPropertyMap = {}
            let promiseList = []
            for (let newProperty of this.newPropertyList) {
                newPropertyMap[newProperty.id] = newProperty
                newProperty.is_unique = this.unique === newProperty.id
                let oldProperty = oldPropertyMap[newProperty.id]
                if (oldProperty) {
                    if (
                        (oldProperty.name !== newProperty.name)
                        || (oldProperty.description !== newProperty.description)
                        || (oldProperty.is_unique !== newProperty.is_unique)
                        || (oldProperty.is_required !== newProperty.is_required)
                    ) {
                        promiseList.push(CampaignService.updateCustomerProperty(this.campaign, oldProperty.id, newProperty))
                    }
                } else {
                    promiseList.push(CampaignService.saveCustomerProperty(this.campaign, newProperty))
                }
            }
            for (let oldProperty of this.oldPropertyList) {
                let newProperty = newPropertyMap[oldProperty.id]
                if (!newProperty) {
                    promiseList.push(CampaignService.removeCustomerProperty(this.campaign, oldProperty.id))
                }
            }
            if (promiseList.length === 0 && this.updateRequiredName === 1) {
                this.close()
                return
            }
            if (promiseList.length + this.updateRequiredName < 1) {
                this.$appService.toastSuccess('No property change')
                this.close()
                return
            }
            Promise.allSettled(promiseList).then(
                resultList => {
                    let updated = 0
                    let error = 0
                    for (let result of resultList) {
                        if (result.status === 'fulfilled') {
                            updated++
                        } else {
                            error++
                        }
                    }
                    if (updated > 0) {
                        this.$appService.toastSuccess(updated + ' properties updated')
                        this.close()
                    }
                    if (error > 0) {
                        this.$appService.toastError(error + ' properties can not be updated')
                    }
                }
            )
        },
        checkKeyExisted (ignoreIndex, value) {
            for (let property of this.fixedPropertyList) {
                if (value === property.name) {
                    return 'Key existed'
                }
            }
            for (let i = 0; i < this.newPropertyList.length; i++) {
                if (i !== ignoreIndex && value === this.newPropertyList[i].name) {
                    return 'Key existed'
                }
            }
            return true
        },
        checkTitleExisted (ignoreIndex, value) {
            for (let property of this.fixedPropertyList) {
                if (value === property.description) {
                    return 'Title existed'
                }
            }
            for (let i = 0; i < this.newPropertyList.length; i++) {
                if (i !== ignoreIndex && value === this.newPropertyList[i].description) {
                    return 'Title existed'
                }
            }
            return true
        },
        openCustomerPropertyCreator () {
            this.$refs.CustomerPropertyCreator.open().then(model => {
                this.newPropertyList.push({
                    id: new Date().getMilliseconds(),
                    name: model.name,
                    description: model.description
                })
            })
        },
        downloadTemplate () {
            CampaignService.getCustomerPropertiesTemplate(this.campaign).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.campaign.title + ' - customer properties template')), '.xlsx')
            })
        },
        importCustomerProperties () {
            this.$refs.InputCustomerProperties.click()
        },
        handleFile (event) {
            this.file = event.target.files[0]
            let extFile = event.target.files[0].type
            if (this.file.size <= 1024 * 1024 && $const.ExcelTypes.includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                this.$http.post(
                    `/campaigns/${this.campaign.id}/import-customer-properties/`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                ).then(
                    res => {
                        this.$appService.toastSuccess(res.data['detail'])
                        this.close()
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.InputCustomerProperties.value = null
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
    },
    beforeDestroy () {
        this.newPropertyList = []
    },
    watch: {
        unique (newId) {
            if (newId) {
                let property = this.newPropertyList.find(i => i.id === newId)
                if (property) {
                    property.is_required = true
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.CampaignCustomerProperties {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;
    width: 100%;

    .btn-custom {
        margin-right: 8px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi", serif;
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .editor-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 12px;
    }

    .dialog-content {
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-radio {
        margin-right: 0 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-input--radio-group {
        .theme--light.v-messages {
            display: none;
        }

        .v-input--selection-controls__input {
            margin-right: 0 !important;
        }
    }
}

.custom-error {
    margin-bottom: 10px;
    display: block;
}

.property-table {
    width: 100%;
    border: 1px solid #96add0;
    border-collapse: collapse;

    thead {
        background: #e4edfa;
    }

    tbody {
        tr {
            border-bottom: 1px solid #E4EDFA;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    tr {
        height: 48px !important;
    }

    td:nth-child(1) {
        padding: 0 6px 0 12px;
    }

    td:nth-child(2) {
        padding: 0 0 0 6px;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    th {
        text-align: left;
        font-size: 14px;
    }

    &::v-deep .v-icon {
        cursor: pointer;
    }
}
</style>
